import * as Reflux from "reflux";

const ListAction = Reflux.createActions(["deleteList", "getRecentList"]);

export default ListAction;
